import React, { Fragment, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Breadcrumbs, Link, Paper } from "@material-ui/core";

// Contexts
import CampaignContext from "../../../context/campaign/CampaignContext";
import ProductContext from "../../../context/checkout/products/ProductContext";

// Components
import Section_Link from "./Section_00";
import Section_Lander from "./Section_01";
import Section_Campaign from "./Section_02";
import Section_Product from "./Section_03";
import Section_Store from "./Section_04";
import Section_Checkout from "./Section_05";
import axios from "../../../axiosinstance";

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(2),
  },
  paper_00: {
    padding: theme.spacing(1, 2, 1, 2),
    color: theme.palette.text.secondary,
  },
  paper: {
    padding: theme.spacing(1, 2, 2, 2),
    color: theme.palette.text.secondary,
  },
}));

const CampaignForm = () => {
  const classes = useStyles();

  const {
    display_content,
    form_data,
    resetCampaignData,
    checkout_data,
    checkout_error,
    setDisplayContent,
    getCampaign,
  } = useContext(CampaignContext);
  const { setAllProducts } = useContext(ProductContext);

  useEffect(() => {
    const paths = window.location.pathname.split("/");

    if (paths.length > 3) {
      const domain = paths[paths.length - 2];
      const campaign_id = paths[paths.length - 1];

      setDisplayContent("Edit");
      getCampaign(domain, campaign_id);
    } else {
      setDisplayContent("Create");
      resetCampaignData();
    }
  }, []);

  useEffect(() => {
    const getProductList = async () => {
      const fieldToQuery = "id,title,variants";
      const result = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}api/products?field=${fieldToQuery}`
      );
      if (result.status === 200) {
        setAllProducts(result.data);
      }
    };
    getProductList();
  }, []);

  return (
    <Fragment>
      {/* Header */}
      <Grid container spacing={1} className={classes.section}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Campaign </Typography>
          </Grid>
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/campaign">
                Active
              </Link>
              <Link color="inherit"> {display_content} </Link>
            </Breadcrumbs>
          </Grid>
        </Grid>
      </Grid>
      {/* Content */}
      <Grid
        container
        spacing={1}
        justifyContent="space-between"
        className={classes.section}
      >
        {display_content === "Edit" && (
          <Grid item xs={12}>
            <Paper className={classes.paper_00}>
              <Section_Link />
            </Paper>
          </Grid>
        )}
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Section_Lander />
          </Paper>
        </Grid>
        {form_data.handle && (
          <Fragment>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Section_Campaign />
                <br /> {form_data.posting_store && <Section_Product />}
                <br /> {form_data.posting_store && <Section_Store />}
              </Paper>
            </Grid>
          </Fragment>
        )}
        {checkout_data?.product_id && checkout_error && (
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Section_Checkout />
            </Paper>
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

export default CampaignForm;
